<div class="mcd-notification-wrapper">
  <ul class="nav-items">
    <!-- Notification Bell Item -->
    <li class="nav-item notification-item" *ngIf="showNotification">
      <button type="button" class="notification-bell-btn" (click)="toggleNotificationDropdown($event)"
        [class.active]="showDropdown">
        <img src="assets/images/bell 2 (1).svg" />
        <span class="notification-badge" *ngIf="notificationUnseenHistory.length > 0">{{
          notificationUnseenHistory.length }}</span>
      </button>

      <!-- Notifications Dropdown Modal -->
      <div class="notification-dropdown-modal" *ngIf="showDropdown" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="notif-modal-header">
          <span class="notif-modal-title">Notifications</span>
          <span class="notif-mark-read" (click)="markAllAsRead()">Mark all read</span>
        </div>

        <!-- Notification List -->
        <div class="notif-modal-list" *ngIf="notificationViewHistory.length > 0">
          <div class="notif-modal-item" [class.unread-item]="!item.isSeen"
            *ngFor="let item of notificationViewHistory; let i = index"
            (click)="rowSelected(item); addendumService.isCommingFromNotification = true">
            <!-- Blue unread dot -->
            <span class="unread-blue-dot" *ngIf="!item.isSeen">•</span>

            <!-- Avatar circle -->
            <div class="notif-item-avatar" [style.background-color]="getNotificationAvatarColor(item, i)">
              {{ getSingleInitial(item.notifiedUser) }}
            </div>

            <!-- Content -->
            <div class="notif-item-content">
              <div class="notif-item-title">{{ item.message }}</div>
              <div class="notif-item-meta">
                <ng-container *ngIf="item.notifiedUser">Added by {{ item.notifiedUser }}
                <ng-container *ngIf="item.notifiedUserRole"> • {{ item.notifiedUserRole }}</ng-container>
                • </ng-container>{{ getTimeAgo(item.date) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div class="notif-modal-empty" *ngIf="notificationViewHistory.length == 0">
          <p>No new notifications</p>
        </div>

        <!-- View All Footer Button -->
        <a class="notif-view-all-btn" [routerLink]="['/notification-list']" (click)="removePopOver()">
          View All
        </a>
      </div>
    </li>

    <!-- User Profile Item & Pill Modal -->
    <li class="nav-item user-profile-wrapper">
      <!-- User Pill Button -->
      <button type="button" class="user-profile-pill" (click)="toggleUserDropdown($event)"
        [class.active]="showUserDropdown">
        <img src="/assets/images/user 1 (1).svg" />
        <span class="user-pill-text">Hi, {{ userName }}</span>
        <svg class="pill-chevron-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" [class.chevron-open]="showUserDropdown">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      <!-- Profile Dropdown Modal -->
      <div class="user-profile-dropdown-modal" *ngIf="showUserDropdown" (click)="$event.stopPropagation()">
        <!-- Header Info -->
        <div class="user-modal-header">
          <div class="user-modal-avatar" [style.background-color]="getUserAvatarColor(userName)">
            {{ getSingleInitial(userName) }}
          </div>
          <div class="user-modal-info">
            <div class="user-modal-name">{{ userName }}</div>
            <div class="user-modal-email">{{ userEmail }}</div>
          </div>
        </div>

        <div class="user-modal-divider"></div>

        <!-- Role & Market Rows -->
        <div class="user-modal-details">
          <!-- User Role Row -->
          <div class="user-detail-row">
            <div class="detail-label-wrap">
              <img src="/assets/images/user-focus 1.svg" />
              <span class="detail-label">User Role</span>
            </div>
            <span class="detail-value">{{ userRoleName }}</span>
          </div>

          <!-- Market Row -->
          <div class="user-detail-row">
            <div class="detail-label-wrap">
              <img src="/assets/images/shop-pin 1 (1).svg" />

              <span class="detail-label">Market</span>
            </div>
            <span class="detail-value">{{ userMarket }}</span>
          </div>
        </div>

        <div class="user-modal-divider"></div>

        <!-- Log out Button -->
        <div class="user-modal-logout" (click)="signOut()">
          <img src="/assets/images/leave 2.svg" />
          <span class="logout-text">Log out</span>
        </div>
      </div>
    </li>
  </ul>
</div>